import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import useUserStore from "./modules/user";
import useSettingStore from "./modules/setting";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export { useUserStore, useSettingStore };
export default pinia;
